
export const columns = [
    {
        title: "序号",
        dataIndex: "ranking",
        key: "ranking",
        width: 100,
        fixed: 'left',
        hidden:false,
    },
    {
        title: "测试主体",
        dataIndex: "deptName",
        key: "deptName",
        // width: 150,
        hidden:false,
    },
    {
        title: "测试牌照",
        key: "carTestNum",
        dataIndex: "carTestNum",
        hidden:false,
    },
    {
        title: "测试区域",
        key: "testZoneNames",
        dataIndex: "testZoneNames",
        hidden:false,
    },
    {
        title: "片区/道路名称",
        key: "testZoneDetailNames",
        dataIndex: "testZoneDetailNames",
        width:240,
        hidden:false,
    },
    {
        title: "测试类型",
        key: "testType",
        dataIndex: "testType",
        hidden:false,
    },
    {
        title: "状态",
        key: "result",
        dataIndex: "result",
        hidden:true,
    },
    {
        title: "测试时间",
        key: "testTime",
        dataIndex: "testTime",
        width:280,
        hidden:false,
    },
    {
        title: "更新时间",
        key: "updateTime",
        dataIndex: "updateTime",
        hidden:false,
    },
    {
        title: "操作",
        key: "action",
        fixed: 'right',
        hidden:false,
        // width: 240,
    },
];

//已审核
export const columns2 = [
    {
        title: "序号",
        dataIndex: "ranking",
        key: "ranking",
        width: 100,
        fixed: 'left',
        hidden:false,
    },
    {
        title: "测试牌照",
        key: "carTestNum",
        dataIndex: "carTestNum",
        hidden:false,
    },
    {
        title: "测试区域",
        key: "testZoneNames",
        dataIndex: "testZoneNames",
        hidden:false,
    },
    {
        title: "片区/道路名称",
        key: "testZoneDetailNames",
        dataIndex: "testZoneDetailNames",
        width:240,
        hidden:false,
    },
    {
        title: "测试类型",
        key: "testType",
        dataIndex: "testType",
        hidden:false,
    },
    {
        title: "状态",
        key: "result",
        dataIndex: "result",
        hidden:true,
    },
    {
        title: "测试时间",
        key: "testTime",
        dataIndex: "testTime",
        width:280,
        hidden:false,
    },
    {
        title: "更新时间",
        key: "updateTime",
        dataIndex: "updateTime",
        hidden:false,
    },
    {
        title: "操作",
        key: "action",
        fixed: 'right',
        hidden:false,
        // width: 240,
    },
];


